"use strict";

exports.__esModule = true;
exports.getMetricFilterKindDefinition = getMetricFilterKindDefinition;
exports.metricFilterKindDefinitions = void 0;
var metricFilterKindDefinitions = exports.metricFilterKindDefinitions = [{
  name: "must",
  label: "is",
  description: "Filter includes values."
}, {
  name: "mustNot",
  label: "is not",
  description: "Filter excludes values.."
}];

/**
 * Get the definition for the metric filter with the given name.
 */
function getMetricFilterKindDefinition(name) {
  for (var i = 0; i < metricFilterKindDefinitions.length; i++) {
    var definition = metricFilterKindDefinitions[i];
    if (definition.name === name) {
      return definition;
    }
  }
  throw new Error("Unknown metric filter kind: " + name);
}